import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'kt-erreur',
  templateUrl: './erreur.component.html',
  styleUrls: ['./erreur.component.scss']
})
export class ErreurComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }



  retour(){
  	this.location.back()
  }
}
